<h2>Inicio</h2>
<p>Bienvenido a la plataforma de Gestión de Agencias, asociada al sistema de recaudo CPE.</p>
